"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const rateReference_schema_1 = __importDefault(require("./schemas/rateReference.schema"));
class CustomerAssignmentDetailValidator extends GenericValidator_1.default {
    _assignmentRatesSchema = joi_1.default.object({
        rates: joi_1.default.array().items(rateReference_schema_1.default).unique().required(),
        rateSheetIds: joi_1.default.array().items(joi_1.default.string()).unique().required(),
    }).required();
    _assignmentSchema = joi_1.default.object({
        default: this._assignmentRatesSchema,
    })
        .required()
        .pattern(/./, this._assignmentRatesSchema);
    _warehousesSchema = joi_1.default.array()
        .items(joi_1.default.object({
        name: joi_1.default.string().required(),
        id: joi_1.default.string().required(),
        measurementStandard: joi_1.default.string().optional(),
        timezone: joi_1.default.string().optional(),
    }))
        .required();
    _schema = joi_1.default.object({
        id: joi_1.default.string().allow('').required(),
        orgKey: joi_1.default.string().required(),
        customerId: joi_1.default.string().required(),
        customerName: joi_1.default.string().allow('').required(),
        warehouses: this._warehousesSchema,
        assignments: this._assignmentSchema,
    }).required();
    validate(input) {
        super.validate(input, 'ICustomerAssignmentDetail', this._schema);
        const issues = [];
        // validates all assignment keys match to a warehouse id
        if (Array.isArray(input?.warehouses)) {
            const allowedWareHouseIds = input?.warehouses?.map((warehouse) => warehouse.id);
            Object.keys(input?.assignments || {})
                .filter((warehouseKey) => warehouseKey !== 'default')
                .forEach((warehouseKey) => {
                if (!allowedWareHouseIds.includes(warehouseKey)) {
                    issues.push(new errors_1.Errors.ValidationIssue('ICustomerAssignmentDetail', errors_1.Errors.ValidationErrorCode.notAllowed, `assignments['${warehouseKey}']`, warehouseKey));
                }
            });
        }
        // validates that if you only have one warehouse, you can't have any extra assignments
        const warehouseCount = input?.warehouses?.length;
        const extraAssignmentCount = Object.keys(input?.assignments || {}).filter((warehouseKey) => warehouseKey !== 'default').length;
        if (warehouseCount === 1 && extraAssignmentCount > 0) {
            issues.push(new errors_1.Errors.ValidationIssue('ICustomerAssignmentDetail', errors_1.Errors.ValidationErrorCode.notAllowed, 'assignments', input.warehouses[0].id));
        }
        if (issues.length > 0) {
            const rateSheetError = new errors_1.Errors.ValidationError();
            issues.forEach((issue) => {
                rateSheetError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
            });
            throw rateSheetError;
        }
    }
}
exports.default = CustomerAssignmentDetailValidator;
